module.exports = __webpack_public_path__ + "img/skills-boy.426a86a7.png";